import React from 'react';

// Helper to parse "Rohit (G A Tours)" or "G A Tours (Rohit)" into main & travels names
export const parseCustomerNameParts = (fullName: string): { mainName: string; travelsName: string } => {
  if (!fullName) return { mainName: '', travelsName: '' };
  
  const match = fullName.match(/^([^(]+)(?:\(([^)]+)\))?/);
  if (match) {
    const part1 = (match[1] || '').trim();
    const part2 = (match[2] || '').trim();
    return { mainName: part1, travelsName: part2 };
  }
  return { mainName: fullName.trim(), travelsName: '' };
};

// Helper to render customer name with Tours & Travels badge in small font
export const renderCustomerNameWithTravels = (fullName: string) => {
  if (!fullName) return <span style={{ color: 'var(--crm-text-muted)' }}>—</span>;
  
  const { mainName, travelsName } = parseCustomerNameParts(fullName);
  
  if (travelsName) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
        <span>{mainName}</span>
        <span style={{
          fontSize: '11px',
          fontWeight: 600,
          background: '#E0F2FE',
          color: '#0369A1',
          padding: '1px 6px',
          borderRadius: '4px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '3px',
          lineHeight: '1.4'
        }}>
          🚌 {travelsName}
        </span>
      </span>
    );
  }
  
  return <span>{fullName}</span>;
};
